export function canonicalMovieLensId(movieId) {
  const numericId = Number(movieId);
  return Number.isInteger(numericId) && numericId > 0 ? numericId : null;
}

export function deduplicateSelectableCatalog(records) {
  const seenMovieIds = new Set();

  return records.filter((record) => {
    const movieId = canonicalMovieLensId(record?.movieId);
    if (movieId !== null) {
      if (seenMovieIds.has(movieId)) return false;
      seenMovieIds.add(movieId);
      return true;
    }

    return false; // Unidentified records cannot be selected or safely deduplicated.
  });
}

export function appendCatalogPage(current, page, recommendations = []) {
  const recommendedIds = new Set(recommendations.map(movie => canonicalMovieLensId(movie.movie_id)));
  return deduplicateSelectableCatalog([...current, ...page])
    .filter(movie => !recommendedIds.has(canonicalMovieLensId(movie.movieId)));
}

export function selectableCatalogMovieIds(records) {
  return deduplicateSelectableCatalog(records)
    .map((record) => canonicalMovieLensId(record.movieId))
    .filter((movieId) => movieId !== null);
}
